import React, { useState, useEffect } from "react";
import "./Rightpart.css";
import "../../Pages/Cart.css";
import profile from "../assets/images/profile.png";
import cartImg from "../../assets/images/cartImg.png";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Link, useNavigate } from "react-router-dom";
import axios from "../../api/axios";

export default function WishlistRight() {
  const [user, setUser] = useState(null);
  const [wishlistItems, setWishlistItems] = useState([]);
  const [quantities, setQuantities] = useState({});
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const handleProfileUpdate = () => {
    const userData = localStorage.getItem("user");
    if (userData) {
      setUser(JSON.parse(userData));
    }
  };

  const fetchWishlist = async () => {
    const token = localStorage.getItem("access_token");
    if (!token) {
      navigate("/login");
      return;
    }
    try {
      setLoading(true);
      const res = await axios.get("/wishlists");
      if (res.data && res.data.data) {
        setWishlistItems(res.data.data);
        // Initialize quantity = 1 for each item
        const qities = {};
        res.data.data.forEach(item => {
          qities[item.id] = 1;
        });
        setQuantities(qities);
      }
      setLoading(false);
    } catch (err) {
      console.error("Error fetching wishlist items:", err);
      setLoading(false);
    }
  };

  useEffect(() => {
    handleProfileUpdate();
    window.addEventListener("user-profile-updated", handleProfileUpdate);

    fetchWishlist();

    return () => {
      window.removeEventListener("user-profile-updated", handleProfileUpdate);
    };
  }, []);

  const handleQtyChange = (itemId, val) => {
    if (val < 1) return;
    setQuantities(prev => ({ ...prev, [itemId]: val }));
  };

  const handleLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("user");
    localStorage.removeItem("wishlist_slugs");
    window.dispatchEvent(new Event("user-profile-updated"));
    window.dispatchEvent(new Event("wishlist-slugs-updated"));
    axios.get("/auth/logout").catch(() => {});
    navigate("/login");
  };

  const handleRemoveWishlist = async (slug) => {
    try {
      const res = await axios.get(`/wishlists-remove-product/${slug}`);
      if (res.status === 200) {
        // Update local cache
        const stored = localStorage.getItem("wishlist_slugs");
        if (stored) {
          const slugs = JSON.parse(stored);
          const updated = slugs.filter(s => s !== slug);
          localStorage.setItem("wishlist_slugs", JSON.stringify(updated));
        }
        window.dispatchEvent(new CustomEvent("wishlist-updated"));
        window.dispatchEvent(new CustomEvent("wishlist-slugs-updated"));
        
        // Refresh wishlist list
        fetchWishlist();
      }
    } catch (err) {
      console.error("Error removing item from wishlist:", err);
    }
  };

  const handleAddToCart = async (product, qty) => {
    const token = localStorage.getItem("access_token");
    if (!token) {
      alert("Please login first to manage your cart.");
      navigate("/login");
      return;
    }

    let userId = null;
    if (user) userId = user.id;

    try {
      const response = await axios.post("/carts/add", {
        user_id: userId,
        id: product.id,
        quantity: qty,
        variant: ""
      });

      if (response.data && response.data.result) {
        alert(`${product.name} added to cart!`);
        window.dispatchEvent(new CustomEvent("cart-updated"));
      } else {
        alert(response.data.message || "Failed to add product to cart.");
      }
    } catch (error) {
      console.error("Error adding product to cart:", error);
      alert(error.response?.data?.message || "Something went wrong.");
    }
  };

  return (
    <div className="outer-div-right">
      <div className="dashbord-right-section">
        <div className="dashbord-header">
          <p className="title-dash">Wishlist</p>
          <div className="dropdown-sections d-flex align-items-center">
            <div className="dropdown">
              <button
                className="btn dropdown-toggle d-flex align-items-center gap-3"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <div className="profile-name">
                  <img src={user?.avatar_original || user?.avatar || profile} alt="" style={{ width: '40px', height: '40px', borderRadius: '50%' }} />
                  <div className="name-mail">
                    <h4>{user?.name || "User"}</h4>
                    <p>{user?.email || user?.phone || "Email/Phone"}</p>
                  </div>
                </div>
                <ExpandMoreIcon />
              </button>

              <ul className="dropdown-menu ">
                <li>
                  <Link className="dropdown-item" to="/profile">
                    Profile
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/support">
                    Support
                  </Link>
                </li>
                <li>
                  <button onClick={handleLogout} className="dropdown-item w-100 text-start border-0 bg-transparent">
                    Logout
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="content-dashborad-outer">
          <div className="cart-page pb-0">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12 p-4">
                  <h4 className="cart-title">{wishlistItems.length} Items</h4>

                  {loading ? (
                    <div className="text-center py-5">
                      <div className="spinner-border text-dark" role="status">
                        <span className="visually-hidden">Loading wishlist...</span>
                      </div>
                    </div>
                  ) : wishlistItems.length === 0 ? (
                    <div className="text-center py-5 text-muted">
                      <h5>Your wishlist is empty.</h5>
                      <p>Explore our products and save your favorites here!</p>
                      <Link to="/products" className="btn btn-dark btn-sm mt-3 px-3 py-2">
                        Browse Products
                      </Link>
                    </div>
                  ) : (
                    wishlistItems.map((item) => (
                      <div className="cart-item" key={item.id}>
                        <Link to={`/product/${item.product.slug}`} style={{ flexShrink: 0 }}>
                          <img
                            src={item.product.thumbnail_image || cartImg}
                            alt={item.product.name}
                            className="img-fluid"
                            style={{ width: "90px", height: "90px", objectFit: "cover", borderRadius: "6px" }}
                          />
                        </Link>

                        <div className="cart-details">
                          <div className="cart-name">
                            <Link to={`/product/${item.product.slug}`} style={{ textDecoration: "none", color: "inherit", fontWeight: 600 }}>
                              {item.product.name}
                            </Link>
                          </div>
                          {item.product.rating > 0 && (
                            <div className="cart-meta text-muted small">Rating: {item.product.rating} ★</div>
                          )}

                          <div>
                            <div className="qty-box">
                              <button onClick={() => handleQtyChange(item.id, (quantities[item.id] || 1) - 1)}>-</button>
                              <p className="number">{quantities[item.id] || 1}</p>
                              <button onClick={() => handleQtyChange(item.id, (quantities[item.id] || 1) + 1)}>+</button>
                            </div>
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                handleAddToCart(item.product, quantities[item.id] || 1);
                              }}
                              className="wishlist"
                            >
                              Add to Cart
                            </a>
                          </div>
                        </div>

                        <div className="cart-price">
                          {item.product.base_price}
                          <button className="remove-btn" onClick={() => handleRemoveWishlist(item.product.slug)}>
                            ×
                          </button>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
